function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return <svg viewBox="0 0 15 14" xmlns="http://www.w3.org/2000/svg" {...props}><g fillRule="evenodd"><path d="M5.475.468h4.212v13.13H5.475zM.39 4.22h4.212v9.38H.39zM10.45 6.1h4.212v7.504H10.45z" /></g></svg>;
});